import React, { Component } from "react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-[#F8F9FA] px-4 text-slate-700">
          <div className="max-w-lg rounded-xl border border-slate-200 bg-white p-8 text-center shadow-sm">
            <h1 className="text-3xl font-bold text-navy-900">
              We&apos;ll Be Right Back
            </h1>
            <p className="mt-3 text-sm leading-relaxed text-slate-600">
              We&apos;re currently performing maintenance or resolving an issue.
              Your patience is appreciated, and we&apos;ll have things back up
              and running soon.
            </p>
            <button
              type="button"
              className="mt-6 rounded-lg bg-[var(--color-teal-600)] px-6 py-2.5 text-sm font-semibold text-white shadow-sm transition duration-300 hover:bg-[var(--color-teal-700)]"
              onClick={() => window.location.reload()}
            >
              Try Again
            </button>
            <p className="mt-4 text-xs text-slate-500">
              If the issue persists, please check back later.
            </p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
